import { motion } from "framer-motion";

import useSidebar from "./useSidebar";
import { sidebarVariants } from "./variants";
import { MenuToggle, Navigation } from "./components";
import "./styles.scss";

const Sidebar = () => {
  const { isOpen, height, containerRef, toggleOpen, clickAwayRef } =
    useSidebar();

  return (
    <motion.nav
      initial={false}
      animate={isOpen ? "open" : "closed"}
      custom={height}
      ref={containerRef}
      className={`sidebar ${isOpen ? "open" : "closed"}`}
    >
      <motion.div
        className="sidebar-background"
        variants={sidebarVariants}
        ref={clickAwayRef}
      />
      <Navigation />
      <MenuToggle toggle={() => toggleOpen()} isOpen={isOpen} />
    </motion.nav>
  );
};

export default Sidebar;
